import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { formatNumber } from 'utilities/utils';

import PopupContent from './popupContentTypes';

const CustomReactPopup = ({ feature, selectedLayerSet, layer }) => {
    const { popupContents } = selectedLayerSet;

    // Popup for non-reference layers:
    if (!layer.referenceLayer) {
        return (
            <>
                {/* Each entry of popupContents is one row, rendered in the order the array
                    lists them. See popupContentTypes.js for what each popupType looks like. */}
                {popupContents.map((content) => (
                    <PopupContent
                        key={`${content.popupType}-${content.field}`}
                        content={content}
                        feature={feature}
                    />
                ))}
                {!layer.omitCommunityProfile ? (
                    <div className="demographic-data-link-container">
                        <a
                            href="#community-profile"
                            className="unset-anchor-styles demographic-data-link"
                        >
                            See demographic data
                            <KeyboardArrowDownIcon fontSize="small" />
                        </a>
                    </div>
                ) : null}
            </>
        );
    }

    const {
        title: referenceTitle,
        customTitle,
        line1,
        line2A,
        line2B,
        line3,
    } = layer.content;

    // Popup for reference layers:
    return (
        <div className="reference-layer-popup">
            <div className="popup-row">
                <div className="popup-title">
                    {customTitle || feature[referenceTitle]}
                </div>
            </div>
            <div className="popup-row">
                <div className="reference-value">
                    {feature[line1] || line1}
                    <br />
                    <div className="popup-line-2-container">
                        {formatNumber(feature[line2A])}
                        {line2B}
                    </div>
                    {feature[line3]}
                </div>
            </div>
        </div>
    );
};

export default CustomReactPopup;
